import { useParams } from 'wouter-preact'
import { useEffect } from 'preact/hooks'
import { navigate } from 'wouter-preact/use-browser-location'
import { ApplicationError, ErrorType } from 'core'
import { useComputed } from '@preact/signals'
import { type ComponentChildren } from 'preact'

import { emitSystemNotification, smartContractsState } from 'state'
import { addDApp } from 'components/UI/organisms/sidebar/state'

interface Props {
	children: ComponentChildren
}

const DashboardDAppTemplate = ({ children }: Props) => {
	const params = useParams()

	const smartContract = useComputed(() =>
		smartContractsState.value.find(
			smrtContract => smrtContract.name === params.dAppName
		)
	)

	useEffect(() => {
		if (!smartContract.value) {
			emitSystemNotification({
				error: new ApplicationError({
					type: ErrorType.NotFound,
					message: 'DApp not found'
				}),
				acceptText: 'Go to dashboard',
				display: 'dialog',
				onCloseCallback: () =>
					navigate(`/dapp/${params.projectId}`, { replace: true })
			})
		} else {
			addDApp(smartContract.value)
		}
	}, [smartContract.value, params.projectId])

	return (
		<div class='relative h-full w-full'>{smartContract.value && children}</div>
	)
}

export { DashboardDAppTemplate }
